import type { JSX, ReactNode } from "react";
import { Pager } from "./Pager";
import type { PagedResult } from "./usePaged";

/** Loading/error/empty/table/pager scaffold for a paginated list. */
export function PagedTable<T>({ paged, headers, renderRow }: {
  paged: PagedResult<T>;
  headers: string[];
  renderRow: (row: T) => ReactNode;
}): JSX.Element {
  if (paged.loading) return <div className="cc-skeleton" style={{ height: 200 }} />;
  if (paged.error) return <div className="cc-empty">加载失败。 <button className="cc-back" onClick={paged.reload}>重试</button></div>;
  return (
    <>
      <table className="cc-table">
        <thead><tr>{headers.map((h) => <th key={h}>{h}</th>)}</tr></thead>
        <tbody>{paged.rows.map(renderRow)}</tbody>
      </table>
      {paged.rows.length === 0 && <div className="cc-empty">暂无数据</div>}
      <Pager page={paged.page} hasMore={paged.hasMore} onPrev={paged.prev} onNext={paged.next} loading={paged.loading} />
    </>
  );
}
